import { useEffect, useLayoutEffect,  useState } from "react";
import { GetAccounts, GetAccount, GetSharesWith, GetSharesWithServiceProvider,  ConvertUnixTimestampToDateString, getInfo, FetchIndividual, GetServiceProvider, GetBeneficiary, GetRequestDetails } from "../utilities/calls";
import { Link } from "react-router-dom";
import { displayDate } from "../utilities/functions";
import BusinessOnboarding from "./BusinessOnboarding";
export default function ServiceRequests() {
    const [individual, setIndividual] = useState({});
    const [showAlert, setShowAlert] = useState();
    const [alertText, setAlertText] = useState();
    const [serviceProviderList, setServiceProviderList] = useState({});
    const [unassignedServiceProviderList, setUnassignedServiceProviderList] = useState({});
    const [sharesReceivedSPList, setSharesReceivedSPList] = useState([]);
    const [benList, setBenList] = useState({});
    const [unassignedBenList, setUnassignedBenList] = useState({});
    const [sharesReceivedBenList, setSharesReceivedBenList] = useState([]);
    const [requests, setRequests] = useState({});
    const [working, setWorking] = useState(true);
    let requestIds = [];

    useLayoutEffect(() => {
        setWorking(true);
        const individualid = getInfo("IndividualID");
        if (individualid == null) return;
        FetchIndividual(individualid)
            .then((individualData) => {
                setIndividual(individualData);
            })
            .catch((error) => {
                console.error("Error fetching individual:", error);
                setShowAlert(true);
                setAlertText("Error fetching individual");
            });

        GetAccounts().then( async (response) => {
            let acpa = [];
            Object.keys(response).forEach((key, index) => {
                const acp = GetAccount(key).then( async (accDetails) => {
                    let sppa = []
                    Object.keys(accDetails.ServiceProviders).forEach((k, i) => {
                        const spp = GetServiceProvider(k).then((spDetails) => {
                            setServiceProviderList((serviceProviderList) => ({ ...serviceProviderList, [spDetails.id]: spDetails }));
                        }).catch((error) => {
                            setShowAlert(true);
                            setAlertText("Error fetching Service Providers from server. Please try again!");
                        });
                        sppa.push(spp);
                        GetSharesWithServiceProvider(k).then((share) => {
                            let sp = share.filter((d) => d.beneficiaryID?.localeCompare("00000000-0000-0000-0000-000000000000") === 0);
                            setSharesReceivedSPList((sharesReceivedSPList) => [...sharesReceivedSPList, ...sp])
                        })
                    })
                    let benpr = [];
                    Object.keys(accDetails.Beneficiaries).forEach((k, i) => {
                        const benp = GetBeneficiary(k).then( async (ben) => {
                            setBenList((benList) => ({ ...benList, [ben.id]: ben }));
                        }).catch((error) => {
                            setShowAlert(true);
                            setAlertText("Error fetching Beneficiaries from server. Please try again!");
                        });
                        benpr.push(benp);
                        GetSharesWith(k).then((share) => {
                            setSharesReceivedBenList((sharesReceivedBenList) => [...sharesReceivedBenList, ...share])
                        })
                    })
                    await Promise.all(sppa,benpr);
                }).catch((error) => {
                        setShowAlert(true);
                        setAlertText("Error fetching acccount details from server. Please try again!");
                });
                acpa.push(acp);
            })

            let uacp = GetAccount("00000000-0000-0000-0000-000000000000").then( async (accDetails) => {
                let usppar = []
                Object.keys(accDetails.ServiceProviders).forEach((k, i) => {
                    const uspp = GetServiceProvider(k).then((spDetails) => {
                        setUnassignedServiceProviderList((unassignedServiceProviderList) => ({ ...unassignedServiceProviderList, [spDetails.id]: spDetails }));
                    }).catch((error) => {
                        setShowAlert(true);
                        setAlertText("Error fetching unassigned Service Providers from server. Please try again!");
                    });
                    GetSharesWithServiceProvider(k).then((share) => {
                        let sp = share.filter((d) => d.beneficiaryID?.localeCompare("00000000-0000-0000-0000-000000000000") === 0);
                        setSharesReceivedSPList((sharesReceivedSPList) => [...sharesReceivedSPList, ...sp])
                    })
                    usppar.push(uspp);
                })
                let ubenpar = []
                Object.keys(accDetails.Beneficiaries).forEach((k, i) => {
                    const ubenp = GetBeneficiary(k).then((ben) => {
                        setUnassignedBenList((unassignedBenList) => ({ ...unassignedBenList, [ben.id]: ben }));
                    }).catch((error) => {
                        setShowAlert(true);
                        setAlertText("Error fetching unassigned Beneficiaries from server. Please try again!");
                    });
                    ubenpar.push(ubenp);
                    GetSharesWith(k).then((share) => {
                        setSharesReceivedBenList((sharesReceivedBenList) => [...sharesReceivedBenList, ...share])
                    })
                })
                await Promise.all(usppar,ubenpar);
            }).catch((error) => {
                setShowAlert(true);
                setAlertText("Error fetching unassigned details from server. Please try again!");
            });
            acpa.push(uacp);
            await Promise.all(acpa);

        }).catch((error) => {
            console.error("Error fetching accounts:", error);
            setShowAlert(true);
            setAlertText("Error fetching data from server. Please try again!");
        }).finally(() => {setWorking(false)});

    }, [])

    useEffect(() => {
        sharesReceivedSPList.forEach((share) => {
            const reqId = share?.tags?.RequestId?.Value;
            if(!reqId) return;
            if(requestIds.findIndex((r) => r === reqId) === -1){
                requestIds.push(reqId);
                GetRequestDetails(share.tags.RequestId.Value).then((req)=>{
                    setRequests((prevRequests) => ({ ...prevRequests, [req.id]: req }));
                }).catch((err) => console.log('Error fetching request details', err)); 
            } 
        })
    }, [sharesReceivedSPList]);

    useEffect(() => {
        sharesReceivedBenList.forEach((share) => {
            const reqId = share?.tags?.RequestId?.Value;
            if(!reqId) return;
            if(requestIds.findIndex((r) => r === reqId) === -1){
                GetRequestDetails(share.tags.RequestId.Value).then((req)=>{
                    setRequests((prevRequests) => ({ ...prevRequests, [req.id]: req }));
                }).catch((err) => console.log('Error fetching request details', err)); 
            } 
        })
    }, [sharesReceivedBenList]);

    const displayActivities = (activities) => {
        
        return activities.sort((a, b) => { return new Date(b.updated) - new Date(a.updated)}).map((a) => {return <Link className="w-full flex flex-row hover:bg-555" to={{ pathname: "/spsharing" }} ><div class="w-full items-center justify-between p-4 border-t shadow-sm sm:flex border-gray-600">
                    <div class="hover:underline p-1 text-sm font-semibold text-gray-300">{a.activityDetails}</div>
                    <time class="md:px-2 mb-1 text-xs font-normal text-gray-400 sm:order-last sm:mb-0" title={a.updated}>{displayDate(a.updated)}</time>
                </div></Link>})
        
    }

    let activities = [];

    sharesReceivedSPList.sort((a,b)=> {return new Date(b.updated) - new Date(a.updated)}).forEach((record) => {
        let activity = {};
        activity.updated = record.updated;
        activity.activityDetails = (requests[record?.tags?.RequestId?.Value]?.toIndividualEmail || "Someone") + " has shared " + (record.requestType === "SHARE_SECUREDCONTENT" ? "Content" : record.requestType === "SHARE_ADDRESS" ? "Address" : "Document") + " with " + (serviceProviderList[record.serviceProviderID]?.tags?.name?.Value || " a service provider" ) ;
        if(activities.findIndex((pact) => pact.activityDetails === activity.activityDetails ) === -1)
            activities.push(activity);
    })

    sharesReceivedBenList.sort((a,b)=> {return new Date(b.updated) - new Date(a.updated)}).forEach((record) => {
        let activity = {};
        activity.updated = record.updated;
        activity.activityDetails = (requests[record?.tags?.RequestId?.Value]?.toIndividualEmail || "Someone") + " has shared " + (record.requestType === "SHARE_SECUREDCONTENT" ? "Content" : record.requestType === "SHARE_ADDRESS" ? "Address" : "Document") + " with " + (benList[record.beneficiaryID]?.tags?.name?.Value || " a beneficiary") ;
        if(activities.findIndex((pact) => pact.activityDetails === activity.activityDetails) === -1)
            activities.push(activity);
    })


    return individual && individual.id ?
        <div className="max-w-screen-xl grid grid-cols-1">
            { !working && Object.keys(serviceProviderList).length === 0 &&
                Object.keys(unassignedServiceProviderList).length === 0 &&
                Object.keys(benList).length === 0 &&
                Object.keys(unassignedBenList).length === 0 ?
                <><h1 className="py-3 bold-text-input">You have no configured Service Provider or Beneficiary. Please select "Services" from above menu to add your business Profile or get started below- </h1>
                <BusinessOnboarding/></>
                : <a href="/home/index.html#/serviceProviders">You have
                    <div className="flex flex-wrap gap-4">
                      {Object.keys(serviceProviderList).length > 0 && (
                        <div className="bg-gradient-to-r from-blue-100 to-blue-200 rounded-xl px-4 py-2 shadow text-sm font-semibold text-blue-900">
                          {Object.keys(serviceProviderList).length}{" "}
                          {Object.keys(serviceProviderList).length === 1 ? "Service Provider" : "Service Providers"}
                        </div>
                      )}

                      {Object.keys(benList).length > 0 && (
                        <div className="bg-gradient-to-r from-green-100 to-green-200 rounded-xl px-4 py-2 shadow text-sm font-semibold text-green-900">
                          {Object.keys(benList).length}{" "}
                          {Object.keys(benList).length === 1 ? "Beneficiary" : "Beneficiaries"}
                        </div>
                      )}

                      {Object.keys(unassignedServiceProviderList).length > 0 && (
                        <div className="bg-gradient-to-r from-yellow-100 to-yellow-200 rounded-xl px-4 py-2 shadow text-sm font-semibold text-yellow-900">
                          Unassigned {Object.keys(unassignedServiceProviderList).length}{" "}
                          {Object.keys(unassignedServiceProviderList).length === 1 ? "Service Provider" : "Service Providers"}
                        </div>
                      )}

                      {Object.keys(unassignedBenList).length > 0 && (
                        <div className="bg-gradient-to-r from-pink-100 to-pink-200 rounded-xl px-4 py-2 shadow text-sm font-semibold text-pink-900">
                          Unassigned {Object.keys(unassignedBenList).length}{" "}
                          {Object.keys(unassignedBenList).length === 1 ? "Beneficiary" : "Beneficiaries"}
                        </div>
                      )}
                    </div>
                </a>
            }
            <h1 className="py-3 bold-text-input">Activity</h1>
            <div>{showAlert ? (<div class="  bg-blue-100 border-blue-500 text-blue-700 px-2 py-2 relative" role="alert" style={{ display: showAlert ? "block" : "none" }}>
                <button className="absolute top-2 right-1 text-lg font-normal text-gray-700 -translate-x-2 " onClick={()=> {setShowAlert(false)}}>X</button><span class="text-sm">{alertText} </span>
            </div>) : <></>}</div>
            {displayActivities(activities)}

        </div>
        : <div></div>
}



